import { render, staticRenderFns } from "./SmsSendingConfirmation.vue?vue&type=template&id=27bf097b&scoped=true"
import script from "./SmsSendingConfirmation.vue?vue&type=script&lang=js"
export * from "./SmsSendingConfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27bf097b",
  null
  
)

export default component.exports